/* eslint-env node */

const PageWrapper = require('./src/components/PageWrapper').default

exports.wrapPageElement = PageWrapper
